import { Popover } from 'bootstrap';

export default function initCardTypes() {

	//account for search result cards
	new MutationObserver(() => {
		document.querySelectorAll( '.card:not(.type-login,.type-contact,.type-team_member,.type-color,.with-link)' ).forEach( ( card ) => {
			if( card.dataset.edited ) return;
			const link = card.querySelector( 'a:not(.js-share-btn, .js-favorite-btn, [href*="appointment-request"]), .button-rsvp' );
			if ( link ) {
				card.classList.add( 'with-link' );
				if(link.classList.contains('external-link-modal') === true){
					card.classList.add('external-link-only');
				}
				card.addEventListener( 'click', (event) => {
					if(link.classList.contains('external-link-modal') === true){
						return false;
					}
					if (event.target.closest('.js-favorite-btn') || event.target.closest('.js-share-btn') || event.target.closest('.button-rsvp') || event.target.closest('.external-link-modal')) {
						event.stopPropagation();
					}else{
						event.preventDefault();
						if (link.target === '_blank') {
							window.open(link.href, '_blank');
						} else {
							window.location.href = link.href;
						}
					}
				});
				//keyboard navigation
				card.addEventListener( 'keydown', (e) => {
					if (e.key === 'Enter') {
						if (document.activeElement === card) {
							e.preventDefault();
							card.click();
						}
					}
				});
			}
		});
	}).observe(document.body, {
		childList: true,
		subtree: true
	});



    // query all .card.type-value_prop elements
    document.querySelectorAll( '.card.type-value_prop' ).forEach( ( card ) => {
        if( card.dataset.edited ) return;
        const parent = card.parentNode;
        const childCards = parent.querySelectorAll( '.card.type-value_prop' );
        // normalize .body height
        const handleResize = () => {
            let maxHeight = 0;
            childCards.forEach((child) => {
                const bod = child.querySelector('.body');
                child.dataset.edited = 'true';
                bod.style.height = 'auto';
                bod.style.maxHeight = '100%';
                if (bod.offsetHeight > maxHeight) {
                    maxHeight = bod.offsetHeight;
                }
            });
            childCards.forEach((child) => {
                const bod = child.querySelector('.body');
                bod.style.minHeight = `${maxHeight}px`;
            });
        }
        handleResize();
        window.addEventListener('resize', handleResize);
    });

    /** configure loan type */
    document.querySelectorAll( '.type-loan_rate' ).forEach( ( card ) => {
        const h2 = card.querySelector( 'h2' );
		if(h2 !== null){
			const h2Contents = h2.innerHTML;
			const h2ContentsWrapped = h2Contents.replace( /%/g, '<span class="percent">%</span>' );
			h2.innerHTML = h2ContentsWrapped;

			const h2Dash = h2.innerHTML;
			const h2DashWrapped = h2Dash.replace(/–/g, '<span class="dash">–</span>' );
			h2.innerHTML = h2DashWrapped;
		}
    });

	const handleShareBtnClick = (event) => {
		event.preventDefault();
		let target = event.target.closest('.js-share-btn').parentNode;
		let create = true;
		const existingPopover = document.querySelectorAll( '.popover' );
		if ( existingPopover ) {
			existingPopover.forEach( (popover) => {
				const id = target.getAttribute('aria-describedby');
				const element = document.getElementById(id);
				if(element){
					create = false;
				}
				popover.remove();
			});
		}
		if(create){
			const targetRect = target.getBoundingClientRect();
			const targetWidth = targetRect.width;
			// let content = document.getElementById('share-popover').cloneNode(true).innerHTML;
			let content = `<div class="share-popover">
				<a class="item copy-link" href="{{link}}" rel="nofollow">
					<span class="icon icon-share-link"></span> <span class="copy">Copy Link</span> <span class="visually-hidden"> to Clipboard for Sharing</span>
				</a>
				<a class="item" href="{{facebook_link}}" rel="nofollow" target="_blank">
					<span class="icon icon-share-facebook"></span> <span class="copy">Share on Facebook</span>
				</a>
				<!-- <a class="item" href="{{instagram_link}}" target="_blank">
					<span class="icon icon-share-instagram"></span> <span class="copy">Share on Instagram</span>
				</a> -->
				<a class="item" href="{{x_link}}" rel="nofollow" target="_blank">
					<span class="icon icon-share-x"></span> <span class="copy">Share on X</span>
				</a>
				<a class="item share-email" href="{{email_link}}" rel="nofollow" target="_blank">
					<span class="icon icon-share-email"></span> <span class="copy">Share by Email</span>
				</a>
			</div>
			`;
			let destination = location.href;

			const closestCard = target.closest( '.post-card' );
			if ( closestCard ) {
				const anchorLink = closestCard.querySelector( 'a:not(.js-share-btn, .js-favorite-btn, [href*="appointment-request"])' );
				if ( anchorLink ) {
					destination = anchorLink.href;
				}
			}


			content = content.replace("{{facebook_link}}", "https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(destination));
			content = content.replace("{{instagram_link}}", "https://www.instagram.com/sharer.php?u="+encodeURIComponent(destination));
			content = content.replace("{{x_link}}", "http://www.twitter.com/share?url="+encodeURIComponent(destination));
			content = content.replace("{{email_link}}", 'mailto:?body='+encodeURIComponent(location.href));
			content = content.replace("{{link}}", destination);


			let popover = new Popover(target, {
				placement: 'bottom',
				html: true,
				offset: (targetWidth / 4)*-1+"px",
				content: content
			});

			target.addEventListener('shown.bs.popover', () => {
				const copyLinks = document.querySelectorAll('.popover .copy-link');
				if (copyLinks.length) {
					copyLinks.forEach( (copyLink) => {
						copyLink.addEventListener('click', (event) => {
							event.preventDefault();
							copyLink.querySelector('.copy').textContent = 'Copied!';
							navigator.clipboard.writeText(copyLink.getAttribute('href'));
							return false;
						});
					});
				}
			});


			const handleClickOutside = (event) => {
				if (!event.target.closest('.popover') && !event.target.closest('.js-share-btn')) {
					document.removeEventListener('click', handleClickOutside, { capture: true });
					popover.dispose();
				}
			};

			document.addEventListener('click', handleClickOutside, { capture: true });
		}
	};

	const shareObserver = new MutationObserver( (mutations) => {
		mutations.forEach( (mutation) => {
			if (mutation.type === 'childList') {
				mutation.addedNodes.forEach( (node) => {
					if (node.nodeType === Node.ELEMENT_NODE) {
						const shareBtns = node.querySelectorAll('.js-share-btn');
						shareBtns.forEach( (shareBtn) => {
							shareBtn.addEventListener('click', handleShareBtnClick);
						});
					}
				});
			}
		});
	});
	shareObserver.observe(document.body, {
		childList: true,
		subtree: true
	});

	document.querySelectorAll('.js-share-btn').forEach( (shareBtn) => {
		shareBtn.addEventListener('click', handleShareBtnClick);
	});

}



